/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Datetimeisaspect5Inputs */



/**

* @param {_Filter_Class_Datetimeisaspect5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_datetimeisaspect5 = /** @type {((inputs?: _Filter_Class_Datetimeisaspect5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Datetimeisaspect5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("ist")
});
export { _filter_class_datetimeisaspect5 as "_filter_class_DateTimeISAspect" }